var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:"dbox-textarea-container",style:({
    backgroundColor: _vm.yellowStyle ? 'var(--bc-note)' : '',
    opacity: _vm.disabled ? '0.5' : "1",
  })},[_c('textarea',{ref:"textarea",style:({
      overflow: _vm.value && _vm.value.length > 0 ? 'auto' : 'hidden',
      height: !_vm.heightAuto ? (_vm.height + "px") : "auto",
    }),attrs:{"name":_vm.id,"id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"blur":_vm.onBlur,"input":_vm.onInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }